var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "userItem" }, [
    _c("div", { staticClass: "editRule-bot-item" }, [
      _c("div", { staticClass: "editRule-bot-item-top" }, [
        _c("div", { staticClass: "editRule-bot-item-top-left" }, [
          _vm._v(" 规则" + _vm._s(_vm.num + 1) + " ")
        ]),
        _c(
          "div",
          {
            staticClass: "editRule-bot-item-top-right",
            on: { click: _vm.delRule }
          },
          [_vm._v(" 删除本规则 ")]
        )
      ]),
      _c("div", { staticClass: "editRule-bot-item-table" }, [
        _c(
          "div",
          {
            staticClass:
              "editRule-bot-item-table-top editRule-bot-item-table-row"
          },
          [
            _c("p", { staticClass: "editRule-bot-item-table-top-title" }, [
              _vm._v("规则条件（多选）:")
            ]),
            _c(
              "el-checkbox",
              {
                model: {
                  value: _vm.item.jobSelected,
                  callback: function($$v) {
                    _vm.$set(_vm.item, "jobSelected", $$v)
                  },
                  expression: "item.jobSelected"
                }
              },
              [_vm._v("职位编码")]
            ),
            _c(
              "el-checkbox",
              {
                model: {
                  value: _vm.item.orgSelected,
                  callback: function($$v) {
                    _vm.$set(_vm.item, "orgSelected", $$v)
                  },
                  expression: "item.orgSelected"
                }
              },
              [_vm._v("组织机构")]
            ),
            _c(
              "el-checkbox",
              {
                model: {
                  value: _vm.item.businessLineSelected,
                  callback: function($$v) {
                    _vm.$set(_vm.item, "businessLineSelected", $$v)
                  },
                  expression: "item.businessLineSelected"
                }
              },
              [_vm._v("业务条线")]
            )
          ],
          1
        ),
        _vm.item.jobSelected !== null && _vm.item.jobSelected
          ? _c(
              "div",
              {
                staticClass:
                  "editRule-bot-item-table-mid editRule-bot-item-table-row "
              },
              [
                _c("p", { staticClass: "editRule-bot-item-table-mid-title" }, [
                  _vm._v("职位编码")
                ]),
                _c(
                  "el-select",
                  {
                    staticStyle: { width: "120px", "margin-right": "130px" },
                    model: {
                      value: _vm.item.userLabelConditionJob.operator,
                      callback: function($$v) {
                        _vm.$set(
                          _vm.item.userLabelConditionJob,
                          "operator",
                          $$v
                        )
                      },
                      expression: "item.userLabelConditionJob.operator"
                    }
                  },
                  _vm._l(_vm.attrList, function(option) {
                    return _c("el-option", {
                      key: option.key,
                      attrs: { label: option.value, value: option.key }
                    })
                  }),
                  1
                ),
                _c(
                  "el-select",
                  {
                    key: _vm.num + 1,
                    ref: "item_list",
                    staticClass: "editRule-bot-item-table-mid-value",
                    staticStyle: {
                      width: "100%",
                      "min-height": "28px",
                      "line-height": "20px"
                    },
                    attrs: { multiple: "" },
                    on: { change: _vm.jobChange },
                    model: {
                      value: _vm.item.userLabelConditionJob.itemIdList,
                      callback: function($$v) {
                        _vm.$set(
                          _vm.item.userLabelConditionJob,
                          "itemIdList",
                          $$v
                        )
                      },
                      expression: "item.userLabelConditionJob.itemIdList"
                    }
                  },
                  _vm._l(_vm.jobList, function(option) {
                    return _c("el-option", {
                      key: option.jobCode,
                      attrs: {
                        label: option.jobName + "/" + option.jobCode,
                        value: option.jobCode
                      }
                    })
                  }),
                  1
                )
              ],
              1
            )
          : _vm._e(),
        _vm.item.orgSelected
          ? _c(
              "div",
              {
                staticClass:
                  "editRule-bot-item-table-mid editRule-bot-item-table-row"
              },
              [
                _c("p", { staticClass: "editRule-bot-item-table-mid-title" }, [
                  _vm._v("组织机构")
                ]),
                _c(
                  "el-select",
                  {
                    staticStyle: { width: "120px", "margin-right": "130px" },
                    model: {
                      value: _vm.item.userLabelConditionOrg.operator,
                      callback: function($$v) {
                        _vm.$set(
                          _vm.item.userLabelConditionOrg,
                          "operator",
                          $$v
                        )
                      },
                      expression: "item.userLabelConditionOrg.operator"
                    }
                  },
                  _vm._l(_vm.attrList, function(option) {
                    return _c("el-option", {
                      key: option.key,
                      attrs: { label: option.value, value: option.key }
                    })
                  }),
                  1
                ),
                _c(
                  "div",
                  { staticClass: "editRule-bot-item-table-mid-value" },
                  [
                    _c("org-select", {
                      attrs: {
                        multiple: true,
                        collapse: false,
                        modal: false,
                        placeholder: "请选择拟稿部门"
                      },
                      model: {
                        value: _vm.item.userLabelConditionOrg.itemIdList,
                        callback: function($$v) {
                          _vm.$set(
                            _vm.item.userLabelConditionOrg,
                            "itemIdList",
                            $$v
                          )
                        },
                        expression: "item.userLabelConditionOrg.itemIdList"
                      }
                    })
                  ],
                  1
                )
              ],
              1
            )
          : _vm._e(),
        _vm.item.businessLineSelected
          ? _c(
              "div",
              {
                staticClass:
                  "editRule-bot-item-table-mid editRule-bot-item-table-row"
              },
              [
                _c("p", { staticClass: "editRule-bot-item-table-mid-title" }, [
                  _vm._v("业务条线")
                ]),
                _c(
                  "el-select",
                  {
                    staticStyle: { width: "120px", "margin-right": "130px" },
                    model: {
                      value: _vm.item.userLabelConditionBusiness.operator,
                      callback: function($$v) {
                        _vm.$set(
                          _vm.item.userLabelConditionBusiness,
                          "operator",
                          $$v
                        )
                      },
                      expression: "item.userLabelConditionBusiness.operator"
                    }
                  },
                  _vm._l(_vm.attrList, function(option) {
                    return _c("el-option", {
                      key: option.key,
                      attrs: { label: option.value, value: option.key }
                    })
                  }),
                  1
                ),
                _c(
                  "el-select",
                  {
                    staticClass: "editRule-bot-item-table-mid-value",
                    attrs: { multiple: "" },
                    model: {
                      value: _vm.item.userLabelConditionBusiness.itemIdList,
                      callback: function($$v) {
                        _vm.$set(
                          _vm.item.userLabelConditionBusiness,
                          "itemIdList",
                          $$v
                        )
                      },
                      expression: "item.userLabelConditionBusiness.itemIdList"
                    }
                  },
                  _vm._l(_vm.buslinList, function(option, i) {
                    return _c("el-option", {
                      key: i,
                      attrs: { label: option.value, value: option.key }
                    })
                  }),
                  1
                )
              ],
              1
            )
          : _vm._e()
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }